
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/event/[eventId]/checkout/date-select",
      function () {
        return require("private-next-pages/event/[eventId]/checkout/date-select.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/event/[eventId]/checkout/date-select"])
      });
    }
  